import { render, staticRenderFns } from "./contratoContratoPendenteProtocoloVirtual.vue?vue&type=template&id=686bc3f8"
import script from "./contratoContratoPendenteProtocoloVirtual.vue?vue&type=script&lang=js"
export * from "./contratoContratoPendenteProtocoloVirtual.vue?vue&type=script&lang=js"
import style0 from "./contratoContratoPendenteProtocoloVirtual.vue?vue&type=style&index=0&id=686bc3f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports